import React from "react";
import { useState } from "react";

//This function is for the input field for the user to set their budget for the trip
function SetBudget() {
  const [budget, setBudget] = useState("");

  //This function will allow the user to change the field value due to the function returns event.target.value, which is the new inputted value

  function handleChange(event) {
    setBudget(event.target.value);
  }

  return (
    <>
      <input
        className="budget-input"
        type="number"
        min="0"
        step="0.01"
        value={budget}
        onChange={handleChange}
        placeholder="Input Budget"
      />
    </>
  );
}

export default SetBudget;


